const getSelectedSignatory = (arr, key) => {
  const selectedSignatories = []
  arr.filter(item => item.select === true).forEach(x => {
    if (selectedSignatories.some(val => val[key] === x[key])) {
      selectedSignatories.forEach(k => {
        if (k[key] === x[key]) {
          // eslint-disable-next-line no-param-reassign
          k.count += 1
        }
      })
    } else {
      const a = {}
      a[key] = x[key]
      a.count = 1
      selectedSignatories.push(a)
    }
  })
  return selectedSignatories
}
export default getSelectedSignatory
